var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarOutlinedHidden = function SvgStarOutlinedHidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#star-outlined-hidden_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.802 8.4-.054-.045.054-.055v.1Zm-.054-.045L3.61 7.4h2.283c0-.1 1.29-1.5 1.29-1.5l.695-1.8.298.8 1.588-1.6L8.773.7C8.574.3 8.276 0 7.879 0s-.794.3-.893.7L5.398 5.1.93 5.3c-.397 0-.795.3-.894.7-.099.4 0 .9.298 1.2l2.978 2.6 1.435-1.445ZM15.82 6.1c-.1-.4-.496-.7-.894-.7h-1.39l-1.985 1.9h.695L10.361 9c-.298.3-.397.7-.298 1.1l.596 2.5-2.085-1.4c-.198-.1-.397-.2-.595-.2h-.1l-4.467 4.5c-.05.05-.124.1-.198.15-.075.05-.15.1-.199.15.199.1.397.2.596.2.198 0 .397 0 .595-.2l3.773-2.6 3.772 2.6c.397.2.794.2 1.191 0 .298-.3.496-.7.397-1.1l-1.191-4.5 3.474-2.9c.298-.3.497-.7.298-1.2h-.1Zm-2.68-4.7c.397-.4.992-.4 1.39 0 .396.4.396 1 0 1.4l-11.913 12c-.397.4-.992.4-1.39 0a.972.972 0 0 1 0-1.4l11.913-12Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star-outlined-hidden_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgStarOutlinedHidden;